import { ReactElement } from "react";

export interface RouteData {
    routeProps: RouteProps;
    name: string;
}

export interface RouteProps {
    path: string;
    element: ReactElement<any, any>
}

export interface Action<T> {
    type: string,
    payload: T
}

export interface KeyValuePayload {
    key: string,
    value: any
}

export interface AuthModel {
    username: string,
    password: string,
}

export interface ValidatorResponse {
    isValidated: boolean,
    message: string
}
export interface DropdownProps {
    placeholder: ReactElement<any, any>
    text: string,
    options?:any
}

export enum MemberTypeEnum {
    ADMIN = 'Admin',
    TEACHER = 'Teacher',
    STUDENT = 'Student',
}
export interface Value {
  value: string;
  label: string;
}

export enum ResultTypeEnum {
    TEST = 'Test',
    EXAM = 'Exam'
}
